import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { HttpResponse } from '@angular/common/http';
import { LotService } from '../../shared/inventory/service/lot.service';
import { Lot } from '../../shared/inventory/model/lot.model';

/**
 * @deprecated FIXME Deprecated use PopupService
 */
@Injectable()
export class LotPopupService {
    private ngbModalRef: NgbModalRef;

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private lotService: LotService

    ) {
        this.ngbModalRef = null;
    }

    /**
     * @deprecated
     */
    open(component: Component, id?: number | any): Promise<NgbModalRef> {
        return new Promise<NgbModalRef>((resolve, reject) => {
            const isOpen = this.ngbModalRef !== null;
            if (isOpen) {
                resolve(this.ngbModalRef);
            }

            if (id) {
                this.lotService.find(id).toPromise()
                    .then((lotResponse: HttpResponse<Lot>) => {
                        const lot: Lot = lotResponse.body;
                        this.ngbModalRef = this.lotModalRef(component, lot);
                        resolve(this.ngbModalRef);
                    });
            } else {
                // setTimeout used as a workaround for getting ExpressionChangedAfterItHasBeenCheckedError
                setTimeout(() => {
                    this.ngbModalRef = this.lotModalRef(component, new Lot());
                    resolve(this.ngbModalRef);
                }, 0);
            }
        });
    }

    lotModalRef(component: Component, lot: Lot): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.lot = lot;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.ngbModalRef = null;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.ngbModalRef = null;
        });
        return modalRef;
    }
}
